// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import ChevronsUpDown from "@store/Library/Components/Toolkit/Icons/ChevronsUpDown";
import ChevronUp from "@store/Library/Components/Toolkit/Icons/ChevronUp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const baseCellStyles = () => css`
    height: auto;
    border: 0;
    text-align: left;
    line-height: ${x => x.theme.design.typography.lineHeight.large}; /* Store Custom Code */
`;

const dataTable: Styleguide["dataTable"] = {
    defaultProps: {
        headerTypographyProps: {
            weight: "inherit",
            size: "inherit",
        },
        cellTypographyProps: {
            size: "inherit",
        },
        sortClickableProps: {
            css: css`
                ${focusStyles()}
                width: 100%;
                height: 100%;
                justify-content: space-between;
                color: inherit;
                text-transform: uppercase; /* Store Custom Code */

                &:hover {
                    text-decoration: underline;
                }
            `,
        },
        sortIconProps: {
            size: 16,
            css: css`
                color: inherit;
                margin-left: 0.5em;
            `,
        },
        sortIconSources: {
            sortable: ChevronsUpDown,
            ascending: ChevronUp,
            descending: ChevronDown,
        },
        css: css`
            border: ${pxToRem(1)} solid ${getColor("common.border")};
        `,
        cssOverrides: {
            header: css`
                ${baseCellStyles()}
                padding: ${pxToRem(12, 16)}; /* Store Custom Code */
                background-color: ${getColor("primary.dark")};
                color: ${getColor("primary.contrast")};
                font-size: ${x => x.theme.design.typography.size.smaller}; /* Store Custom Code */
                font-weight: ${x => x.theme.design.typography.weight.bold}; /* Store Custom Code */
                text-transform: uppercase; /* Store Custom Code */
            `,
            cell: css`
                ${baseCellStyles()}
                padding: ${pxToRem(20, 16)}; /* Store Custom Code */
                font-size: ${x => x.theme.design.typography.size.smaller};
                font-weight: inherit;
            `,
        },
    },
};

export default dataTable;
